<template>
  <v-dialog v-model="dialog" @keydown.esc="dialog = false" max-width="400px">
    <v-card>
      <v-form ref="form" lazy-validation>
        <v-card-title>
          <span class="headline">{{ $t("confirm") }} {{ $t("action") }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row justify="center">
              {{ $t("confirmFunctionHint") }}
            </v-row>

            <v-row class="red--text" justify="center">
              {{ repeatString }}
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  v-model="checkString"
                  :rules="rules.compared"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <small>*{{ $t("indicates-required-field") }}</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="dialog = false">
            {{ $t("close") }}
          </v-btn>

          <v-btn color="primary" text @click="doFunction">
            {{ $t("confirm") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    repeatString: String,
  },
  data() {
    return {
      dialog: false,
      checkString: "",
      rules: {
        compared: [(v) => v == this.repeatString || this.$t("rule-compared")],
      },
    };
  },
  methods: {
    doFunction() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.checkString == this.repeatString) {
        this.$emit("doFunction");
        this.dialog = false;
      }
    },
  },
};
</script>